import React from 'react';
import { useQuery } from '@apollo/client';
import { Badge } from 'reactstrap';
import { adminInfoStoreWithContactsQuery } from '../../graphql/queries';
import { EditItem } from '../../components/Layout';
import { StoreContact } from '../../graphql/generatedTypes';

type SalesforceContactsProps = {
  storeId: string | null;
  contacts?: Partial<StoreContact>[];
};

export const SalesforceContacts = function SalesforceContacts({
  storeId,
  contacts: contactsIn,
}: SalesforceContactsProps) {
  const { data, loading: loadingStore } = useQuery(
    adminInfoStoreWithContactsQuery,
    {
      fetchPolicy: 'no-cache',
      skip: !storeId || contactsIn != null,
      variables: { id: storeId },
    },
  );

  const contacts: Partial<StoreContact>[] =
    contactsIn || (data && data.store && data.store.contacts) || [];

  return (
    <div className="mb-3 mt-3">
      <EditItem title="Contacts" lockIcon={true}>
        {loadingStore && <p>Loading...</p>}
        {!loadingStore &&
          contacts.map((contact) => (
            <div key={contact.id} className="mb-3">
              {contact.contact_departments &&
                contact.contact_departments.length > 0 && (
                  <div className="mb-1">
                    {contact.contact_departments.map((dept) => (
                      <Badge
                        key={dept}
                        color="primary"
                        className="me-1"
                        style={{ fontSize: '0.85em' }}
                      >
                        {dept}
                      </Badge>
                    ))}
                  </div>
                )}
              <a
                href={contact.link || undefined}
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>
                  {contact.salutation ? `${contact.salutation} ` : ''}
                  {contact.name}
                </strong>
                {contact.title ? ` - ${contact.title}` : ''}
              </a>
              <br />
              {contact.email && (
                <>
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  {(contact.secondary_email ||
                    contact.phone ||
                    contact.mobile) &&
                    ' · '}
                </>
              )}
              {contact.secondary_email && (
                <>
                  <a href={`mailto:${contact.secondary_email}`}>
                    {contact.secondary_email}
                  </a>
                  {(contact.phone || contact.mobile) && ' · '}
                </>
              )}
              {contact.phone && (
                <>
                  <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                  {contact.mobile && ' · '}
                </>
              )}
              {contact.mobile && (
                <a href={`tel:${contact.mobile}`}>📱 {contact.mobile}</a>
              )}
              {(contact.language ||
                (contact.roles && contact.roles.length > 0)) && <br />}
              {contact.language && (
                <small className="text-muted">
                  Language: {contact.language}
                </small>
              )}
              <hr />
            </div>
          ))}
      </EditItem>
    </div>
  );
};
